import BillViewIcon from '@material-ui/icons/ViewList';

import BillViewList from './BillViewList';

export default {
  list: BillViewList,
  icon: BillViewIcon,
};
